import { del, get, post, put } from "@/api/common/request";

// /users/recruiter/list
// 入参：page_num、page_size（可选 query：用于关键字搜索，若后端支持）
export const listRecruiters = (params = {}) => get("/users/recruiter/list", params);

// /users/recruiter/add
export const addRecruiter = (params = {}) => post("/users/recruiter/add", params);

// /users/recruiter/edit
export const editRecruiter = (params = {}) => put("/users/recruiter/edit", params);

// /users/recruiter/remove
// 入参：userid
export const removeRecruiter = (params = {}) => del("/users/recruiter/remove", params);

// /oa/search/oaUser
// 入参：query
// 默认传 "00"，截取 10 条（后端控制）
export const searchOaUsers = (params = {}) => get("/oa/search/oaUser", params);

